/**
 * @desc 详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.CertificationDocumentDetailResponseDto>;
export function request(id: number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/certificationDocument/detail/${id}`, {
      method: "GET",

      ...options,
    }),
  );
}
